
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import FeaturesSection from './components/FeaturesSection';
import ReasonsSection from './components/ReasonsSection';
import ContactSection from './components/ContactSection';

export default function Home() {
  return (
    <div className="min-h-screen bg-white" style={{ fontFamily: '"Noto Sans JP", sans-serif' }}>
      <Header />
      <main>
        <HeroSection />
        <FeaturesSection />
        <ReasonsSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}
